import http from '../http'

/**
 * 获取内容
 * @param  {number} id 内容主键
}
 */
export const getSingle = id => {
    return http.get(`/api/gm/single/get/${id}`)
}
/**
 * 获取列表
}
*/
export const getList = () => {
    return http.get('/api/gm/single/getlist')
}

/**
 * 添加内容
 * @param {FormData} content 内容,例:  {
    "id": 0,
    "title": '标题',
    "info": '内容',
}
*/
export const addSingle = content => {
    return http.post('/api/gm/single/add', content)
}
/**
 * 修改内容
 * @param {FormData} content 内容,例:  {
     "id": '内容主键',
    "title": '标题',
    "info": '内容',
}
*/
export const editSingle = content => {
    return http.post('/api/gm/single/edit', content)
}

/**
 * 彻底删除
 * @param  {number} id 主键
}
 */
export const deleteSingle = id => {
    return http.get(`/api/gm/single/delete/${id}`)
}


// WEBPACK FOOTER //
// ./src/api/gm/api-single.js